const $generateDataFileEl = $('.generateDataFile');
const $downloadMessage = $('.downloadMessage');

$generateDataFileEl.click((e) => {
    e.preventDefault();

    const $thisLink = $(e.currentTarget);
    const downloadUrl = $thisLink.attr('href');

    if ($downloadMessage.hasClass('d-none')) {
        $downloadMessage.toggleClass('d-none d-flex');
    }

    $downloadMessage.html('<b>Loading</b>');
    $.ajax({
        url: downloadUrl,
        dataType: 'json',
        success: function (data) {
            $downloadMessage.html('<b>File is ready:</b> <a href="' + data + '" target="_blank">Click To Download</a>');
        },
        error: function (error) {
            $downloadMessage.html('<b>Opps! Some error occurred.</b>');
        }
    });
});